import React, { lazy, useCallback, useEffect, useMemo, useState } from 'react'
import { Grid, makeStyles, Typography, FormLabel, IconButton, Button } from '@material-ui/core'
import TextBox from '../../../../../shared/elements/FormItem/TextBox'
import { relationshipOptions } from '../../../../../containers/AppointmentBooking/constant'
import Autocomplete from '@mui/material/Autocomplete'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import uploadIcon from '../../../../../../src/assests/images/upload.png'
import { Dialog } from '@mui/material'
import Files from 'react-butterfiles'
import { styled } from '@material-ui/core'
import LinearProgress, { linearProgressClasses } from '@mui/material/LinearProgress'
import IconDragnDrop from '../../../../../../src/assests/images/insuranceCard.png'
import InsuranceCard from './InsuranceCard'
import CloseIcon from '@mui/icons-material/Close';
import { useDispatch, useSelector } from 'react-redux'
import fileIcon from '../../../../../../src/assests/images/fileIcon.svg'
import CheckboxOption from '../../../../ClinicalNotes/reusable/CheckboxOptions'
import HighlightOffIcon from '@mui/icons-material/HighlightOff';

const useStyles = makeStyles(() => ({
    container: {
        width: '100%',
        marginBottom: '17px',
    },
    checkboxLabel: {
        '& .MuiFormControlLabel-root': {
            marginRight: '0 !important',
            '& .MuiIconButton-root': {
                paddingBottom: '0 !important',
                paddingTop: '0 !important',
            },
        },
    },
    container2: {
        width: '100%',
        marginTop: '15px',
        borderTop: '1px solid #CFCFCF',
    },
    uploadButton: {
        border: '1px solid #5473C9',
        borderRadius: '5px',
        color: '#4C67B2',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        padding: '10px',
        marginTop: '12px'
    },
    crossButton: {
        color: '#838383',
        fontSize: '13px',
        display: 'flex',
        justifyContent: 'flex-end',
        padding: '10px',
        cursor:'pointer'
    },
    completebutton:{
        color: '#fff',
        fontFamily: 'Inter',
        fontWeight: 500,
        fontSize: '13px'
    },
    insuranceBoxContainer:{
        display: 'flex',
        gap: '38px', 
        justifyContent:'flex-start',
        ['@media (max-width:768px)']: {
            flexDirection: 'column',
          },
    },
    fileName:{
        fontFamily: 'Inter',
        fontWeight: 450,
        fontSize: '15px',
        color: '#4765B8',
        padding: '0px 7px',
        borderRight: '1px solid black'
    },
    replaceButton:{
        fontFamily: 'Inter',
        fontWeight: 500,
        fontSize: '15px',
        color: 'black',
        padding: '0px 5px',
        cursor: 'pointer'
    },
    secondaryUploadButton:{
        display: 'flex', 
        alignItems: 'center',
        gap: '5px', 
        marginTop: '5px', 
        cursor: 'pointer'
    }
}))


function CreateInsuranceForm(props) {
    const classes = useStyles()
    const [insuranceModal, setInsuranceModal] = useState(false)
    const frontInsurance = useSelector((state) => state?.clinicalNotes?.insurancefrontCard)
    const backInsurance = useSelector((state) => state?.clinicalNotes?.insurancebackCard)

    useEffect(() => {
        if (
            props.formik.values?.carrier ||
            props.formik.values?.group_name ||
            props.formik.values?.group_number ||
            props.formik.values?.subscriber_id ||
            props.formik.values?.relationShip
        ) {
            props.formik.setTouched({
                ...props.formik.touched,
                carrier: true,
                subscriber_id: true,
                relationShip: true,
            })
        } else {
            props.formik.setTouched({
                ...props.formik.touched,
                carrier: false,
                subscriber_id: false,
                relationShip: false,
            })
        }
    }, [props.formik.values])

    useEffect(() => {
        if (props.formik.values?.carrier || !props.carrierList?.length) return

        const nonSelfPayCarriers = props.carrierList.filter(
            (carrier) => carrier?.['@name']?.toLowerCase() !== 'self pay'
        )
        const carrierToSelect =
            nonSelfPayCarriers.length === 1
                ? nonSelfPayCarriers[0]
                : props.carrierList.length === 1
                    ? props.carrierList[0]
                    : null

        if (!carrierToSelect) return

        props.formik.setFieldValue('carrier', carrierToSelect)

        if (carrierToSelect?.['@name']?.toLowerCase() === 'self pay') {
            props.formik.setFieldValue('relationShip', {key: '18', value: 'Self'})
            props.formik.setFieldValue('subscriber_id', '00000')
            props?.setSelfpay(true)
        } else {
            props?.setSelfpay(false)
        }
    }, [props.carrierList, props.formik.values?.carrier])

    const displayName = (name) => {
        let displayName = name;
        const [fileName, extension] = name.split(".");
        displayName = fileName.slice(0, 20) + "..." + " "+"." + extension;
        return displayName
    }
    return (
        <div className="booking_boxes">
            <div>
                <Typography className="step-headers">
                    Please fill out your insurance information
                </Typography>
            </div>
            <div className={`patient-form-outline`}>
                <>
                    <Grid container className={classes.container} spacing={2} xs={12}>
                        {/* <div>
                            <span className="form-header">Insurance Information</span>
                            <div>
                                <CheckboxOption
                                    checked={props.selfpay}
                                    onChange={(event) => {handleChecked(event?.target?.checked)}}
                                    option={{
                                        label: 'Self pay',
                                        value: props.selfpay,
                                    }}
                                />
                            </div>
                        </div> */}
                        <Grid container alignItems="flex-start" spacing={2}>
                            <Grid item xs={12} lg={6} md={6}>
                                <FormLabel
                                    component="p"
                                    className="d-flex justify-space-between align-center"
                                    style={{ fontSize: 14, fontWeight: 500 }}>
                                    <span
                                        className={`${classes.checkboxLabel} required`}
                                        style={{ color: '#303E4E' }}>
                                        <span 
                                            // style={{ opacity: props?.selfpay ? '0.5' : '' }}
                                        >
                                            Health plan{' '}
                                        </span>
                                    </span>
                                </FormLabel>
                                <Autocomplete
                                    value={props.formik.values.carrier || null}
                                    options={props?.carrierList}
                                    getOptionLabel={(states) => states['@name']}
                                    onChange={(_, newValue) => {
                                        if(newValue?.['@name']?.toLowerCase() == 'self pay'){
                                            props.formik.setFieldValue('carrier', newValue)
                                            props.formik.setFieldValue('relationShip', {key: '18', value: 'Self'})
                                            props.formik.setFieldValue('subscriber_id', '00000')
                                            props?.setSelfpay(true)
                                        }else{
                                            props.formik.setFieldValue('carrier', newValue)
                                            props.formik.setFieldValue('relationShip', null)
                                            props.formik.setFieldValue('subscriber_id', '')
                                            props?.setSelfpay(false)
                                        }
                                    }}
                                    popupIcon={<ExpandMoreIcon />}
                                    // disableClearable={false}
                                    // disabled={props.selfpay}
                                    renderInput={(params) => (
                                        <TextBox
                                            name="Textname"
                                            {...params}
                                            placeholder=""
                                            variant="outlined"
                                            error={
                                                props.formik.touched.carrier &&
                                                Boolean(props.formik.errors.carrier)
                                            }
                                            helperText={
                                                props.formik.touched.carrier &&
                                                props.formik.errors.carrier
                                            }
                                        />
                                    )}
                                />
                                {!props.formik.values.carrier &&
                                <div style={{marginTop: '10px', fontSize:'11px', fontWeight:'400', fontFamily:'Inter'}}>If you are unable to locate your health plan, please select 'Self pay'  and give us a call at (562) 268-0955.</div>}
                            </Grid>
                            <Grid item xs={12} lg={6} md={6}>
                                <TextBox
                                    label="Subscriber ID"
                                    required
                                    name="subscriber_id"
                                    placeholder=""
                                    disabled={props?.selfpay}
                                    value={props.formik.values.subscriber_id}
                                    onChange={(value) => {
                                        props.formik.setFieldValue('subscriber_id', value)
                                    }}
                                    error={
                                        props.formik.touched.subscriber_id &&
                                        Boolean(props.formik.errors.subscriber_id)
                                    }
                                    helperText={
                                        props.formik.touched.subscriber_id &&
                                        props.formik.errors.subscriber_id
                                    }
                                />
                            </Grid>
                        </Grid>
                        <Grid
                            container
                            alignItems="flex-start"
                            spacing={2}
                            style={{ marginTop: '5px' }}>
                            <Grid item xs={12} lg={6} md={6}>
                                <TextBox
                                    label="Group Name"
                                    name="group_name"
                                    placeholder=""
                                    value={props.formik.values.group_name}
                                    disabled={props.selfpay}
                                    onChange={(value) => {
                                        props.formik.setFieldValue('group_name', value)
                                    }}
                                    error={
                                        props.formik.touched.group_name &&
                                        Boolean(props.formik.errors.group_name)
                                    }
                                    helperText={
                                        props.formik.touched.group_name &&
                                        props.formik.errors.group_name
                                    }
                                />
                            </Grid>
                            <Grid item xs={12} lg={6} md={6}>
                                <TextBox
                                    label="Group Number"
                                    name="group_number"
                                    placeholder=""
                                    value={props.formik.values.group_number}
                                    disabled={props.selfpay}
                                    onChange={(value) => {
                                        props.formik.setFieldValue('group_number', value)
                                    }}
                                    error={
                                        props.formik.touched.group_number &&
                                        Boolean(props.formik.errors.group_number)
                                    }
                                    helperText={
                                        props.formik.touched.group_number &&
                                        props.formik.errors.group_number
                                    }
                                />
                            </Grid>
                        </Grid>
                        <Grid
                            container
                            alignItems="flex-start"
                            spacing={2}
                            style={{ marginTop: '5px' }}>
                            <Grid item xs={12} lg={6} md={6}>
                                <FormLabel
                                    component="p"
                                    className="d-flex justify-space-between align-center"
                                    style={{ fontSize: 14, fontWeight: 500 }}>
                                    <span
                                        className={`${classes.checkboxLabel} required`}
                                        style={{ color: '#303E4E' }}>
                                        <span style={{ opacity: props.selfpay ? '0.5' : '' }}>
                                            Relationship to patient{' '}
                                        </span>
                                    </span>
                                </FormLabel>
                                <Autocomplete
                                    value={props.formik.values.relationShip || null}
                                    options={relationshipOptions}
                                    getOptionLabel={(states) => states.value}
                                    onChange={(_, newValue) => {
                                        
                                            props.formik.setFieldValue('relationShip', newValue)
                                        
                                    }}
                                    popupIcon={<ExpandMoreIcon />}
                                    disableClearable={false}
                                    disabled={props.selfpay}
                                    renderInput={(params) => (
                                        <TextBox
                                            name="Textname"
                                            {...params}
                                            placeholder=""
                                            variant="outlined"
                                            error={
                                                props.formik.touched.relationShip &&
                                                Boolean(props.formik.errors.relationShip)
                                            }
                                            helperText={
                                                props.formik.touched.relationShip &&
                                                props.formik.errors.relationShip
                                            }
                                        />
                                    )}
                                />
                            </Grid>
                            <Grid item xs={12} lg={6} md={6}>
                                {props?.patientInsuranceFront?.name && (
                                    <>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '5px', marginTop: '15px', justifyContent:'space-between' }}>
                                            <div style={{ display: 'flex', alignItems: 'center'}}>
                                                <img src={fileIcon}/>
                                                <Typography className={classes.fileName}>{props?.patientInsuranceFront?.name.length > 20 ? displayName(props?.patientInsuranceFront?.name) : props?.patientInsuranceFront?.name}</Typography>
                                                <span
                                                    className={classes.replaceButton}
                                                    onClick={() => {
                                                        setInsuranceModal(true)
                                                    }}>
                                                    Replace
                                                </span>
                                            </div>
                                            <IconButton onClick={()=>{props?.setPatientInsuranceFront('')}}>
                                                <HighlightOffIcon style={{color:'#444444'}}/>
                                            </IconButton>
                                        </div>
                                        {!props?.patientInsuranceBack?.name &&
                                            <div className={classes?.secondaryUploadButton} onClick={() => {
                                                setInsuranceModal(true)
                                            }}>
                                                <img src={uploadIcon}
                                                    alt=""
                                                    style={{ marginLeft: '-3px' }}/>
                                                <Typography className={classes.fileName} style={{borderRight:'unset'}}>Upload</Typography>
                                            </div>
                                        }
                                    </>
                                )}
                                {props?.patientInsuranceBack?.name && (
                                    <>
                                        {!props?.patientInsuranceFront?.name &&
                                            <div className={classes?.secondaryUploadButton} onClick={() => {
                                                setInsuranceModal(true)
                                            }}>
                                                <img src={uploadIcon}
                                                    alt=""
                                                    style={{ marginLeft: '-3px' }}/>
                                                <Typography className={classes.fileName} style={{borderRight:'unset'}}>Upload</Typography>
                                            </div>
                                        }
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '5px', marginTop: '5px', justifyContent:'space-between'}}>
                                            <div style={{ display: 'flex', alignItems: 'center'}}>
                                                <img src={fileIcon}  />
                                                <Typography className={classes.fileName}>{props?.patientInsuranceBack?.name.length > 20 ? displayName(props?.patientInsuranceBack?.name) : props?.patientInsuranceBack?.name}</Typography>
                                                <span
                                                    className={classes.replaceButton}
                                                    onClick={() => {
                                                        setInsuranceModal(true)
                                                    }}>
                                                    Replace
                                                </span>
                                            </div>
                                            <IconButton onClick={()=>{props?.setPatientInsuranceBack('')}}>
                                                <HighlightOffIcon style={{color:'#444444'}}/>
                                            </IconButton>
                                        </div>
                                    </>
                                )}
                                {!props?.patientInsuranceFront?.name &&
                                    !props?.patientInsuranceBack?.name && (
                                        <div
                                            className={classes.uploadButton}
                                            style={{ opacity: props?.selfpay ? '0.5' : '' }}
                                            onClick={() => {
                                                if(!props?.selfpay){
                                                    setInsuranceModal(true)
                                                }
                                            }}>
                                            {' '}
                                            Upload picture of your insurance card{' '}
                                            <img
                                                src={uploadIcon}
                                                alt=""
                                                style={{ marginLeft: '3px' }}></img>
                                        </div>
                                    )}
                            </Grid>
                        </Grid>
                    </Grid>
                </>
            </div>
            <Dialog
                open={insuranceModal}
                onClose={() => setInsuranceModal(false)}
                PaperProps={{
                    style: { maxWidth: 'unset' },
                }}>
                <div className={classes.crossButton} onClick={() => setInsuranceModal(false)}>
                    <CloseIcon />
                </div>
                <div style={{ padding: !props?.isMobileView && '0px 33px 33px 33px' }}>
                    <div className={classes?.insuranceBoxContainer}>
                        <InsuranceCard
                            placeholder={'Front of Insurance Card'}
                            insurance={props?.patientInsuranceFront}
                            setPatientInsurance={props?.setPatientInsuranceFront}
                            uploadProgress={props?.uploadProcessFront}
                            setUploadProgress={props?.setUploadProcessFront}
                        />
                        <InsuranceCard
                            placeholder={'Back of Insurance Card'}
                            insurance={props?.patientInsuranceBack}
                            setPatientInsurance={props?.setPatientInsuranceBack}
                            uploadProgress={props?.uploadProcessBack}
                            setUploadProgress={props?.setUploadProcessBack}
                        />
                    </div>
                    <div className={classes.crossButton}>
                        <Button
                            variant="contained"
                            // sx={{
                            //     background: '#5473C9',
                            //     textTransform: 'none',
                            //     '&:hover': {
                            //         backgroundColor: '#5473C9',
                            //     },
                            // }}
                            className='providerDetailsButton'
                            disabled={
                                !props?.patientInsuranceFront?.name &&
                                !props?.patientInsuranceBack?.name
                            }
                            onClick={() => setInsuranceModal(false)}>
                            <span className={classes.completebutton}> Complete</span>
                        </Button>
                    </div>
                </div>
            </Dialog>
        </div>
    )
}
export default React.memo(CreateInsuranceForm)
